import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutUs.css";
import PlantLogo from "../assets/plants.jpeg";
import ProductLogo from "../assets/products.jpeg";
import DeskLogo from "../assets/desk.jpeg";
import CardComponent from "./CardComponent";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

function AboutUs() {
  const [enquiryData, setEnquiryData] = useState({
    contact_person: "",
    email: "",
    message: "",
    company_name: "",
    phone: "",
    inquiry_type: "",
  });
  const [enquiryStatus, setEnquiryStatus] = useState(null);
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  const inquiryTypes = [
    { value: "bulk_order", label: "Bulk Order" },
    { value: "collaboration", label: "Collaboration" },
    { value: "service_request", label: "Service Request" },
  ];

  const handleInputChange = (e) => {
    setEnquiryData({ ...enquiryData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}/account/inquiries/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(enquiryData),
      });

      if (response.ok) {
        setEnquiryStatus("success");
        startSuccessAnimation();
        setEnquiryData({
          contact_person: "",
          email: "",
          message: "",
          company_name: "",
          phone: "",
          inquiry_type: "",
        });
      } else {
        setEnquiryStatus("error");
      }
    } catch (error) {
      setEnquiryStatus("error");
    }
  };

  const startSuccessAnimation = () => {
    setProgress(0);
    let currentProgress = 0;
    const interval = setInterval(() => {
      currentProgress += 2;
      setProgress(currentProgress);
      if (currentProgress >= 100) {
        clearInterval(interval);
        setTimeout(() => setEnquiryStatus(null), 500);
      }
    }, 50);

    setTimeout(() => setEnquiryStatus(null), 5000);
  };

  // Handle Category Click
  const handleCategoryClick = (category) => {
    navigate(`/products/${category}`);
  };

  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-us-hero">
        <div>
          <h1 style={{lineHeight: "1"}}>
            <p>Vastu</p>
            <p>Salahkar</p>
          </h1>
          <h2>Transforming Spaces, Empowering Lives</h2>
          <p>
            {/* Bridging ancient Vastu wisdom with modern technology to create harmonious spaces and empower lives. */}
            At Vastu Salahkar, we blend the timeless principles of ancient Vastu Shastra with the precision of modern technology to craft spaces that radiate harmony, balance, and positive energy. Our mission is to align environments with natural forces, fostering well-being, prosperity, and inner peace for individuals and communities alike.
          </p>
        </div>
      </section>

      {/* Mission and Vision Section */}
      <section className="mission-vision" 
      // style={{ backgroundColor: "#f9f9f9"}}
      >
        <div
         className="responsive-grid"
          // style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}
        >

          <div className="commonSection">
            <h2>Our Mission</h2>
            <p>
              {/* To provide holistic Vastu solutions that cater to diverse user needs, offering a seamless integration of curated plants, specialized products, and personalized solutions. */}
              Our mission is to deliver comprehensive and holistic Vastu solutions tailored to the unique needs of every individual. By seamlessly integrating thoughtfully curated plants, specialized products, and personalized guidance, we aim to create balanced environments that nurture harmony, well-being, and positive transformation.
            </p>
          </div>

          <div className="commonSection">
            <h2>Our Vision</h2>
            <p>
              To position Vastu Salahkar as the most trusted and innovative leader in Vastu solutions, empowering individuals to transform their spaces into vibrant hubs of positive energy, harmony, and holistic well-being.
            </p>
          </div>

          <div className="commonSection">
            <h2>Our Values</h2>
            <p>
              We are guided by the synergy of ancient wisdom and modern innovation, delivering personalized Vastu solutions that foster harmony, balance, and well-being in every space we touch.</p>
          </div>

          <div className="commonSection">
            <h2>Our Culture</h2>
            <p>
              Rooted in empathy, authenticity, and continuous growth, our culture embraces a client-first mindset while honoring the timeless essence of Vastu in every step of our journey.</p>
          </div>

        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us" >
        <div style={{ display: "grid", placeItems: "center", marginBottom: "2rem" }}>
          <h2>Why Choose Us?</h2>
        </div>
        <div className="row justify-content-center">
          <CardComponent
            onClick={() => handleCategoryClick("plants")}
            title="Vastu Plants"
            description="Discover a wide range of Vastu plants to enhance positive energy."
            image={PlantLogo}
          />
          <CardComponent
            onClick={() => handleCategoryClick("products")}
            title="Vastu Products"
            description="Explore our curated Vastu products for your spaces."
            image={ProductLogo}
          />
          <CardComponent
            onClick={() => handleCategoryClick("desk_energy")}
            title="Desk Energy"
            description="Get expert Vastu consultations tailored to your needs."
            image={DeskLogo}
          />
        </div>
      </section>

      {/* Our Team Section */}
      <section className="our-team" 
      // style={{ backgroundColor: "#f9f9f9" }}
      >
        <div style={{ display: "grid", placeItems: "center" }}>
          <h2>Meet Our Team</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "2rem" }}>
          <div className="team-member card" style={{ border: "none", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", transition: "transform 0.2s" }}>
            <img
              src={PlantLogo}
              alt="Rambabu Patidar"
              className="card-img-top img-fluid"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
                margin: "1rem auto",
              }}
            />
            <div className="card-body text-center">
              <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>Rambabu Patidar</h3>
              <p className="card-text" style={{ fontSize: "1rem", color: "#555" }}>Tech and Vastu Visionary</p>
            </div>
          </div>
          <div className="team-member card" style={{ border: "none", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", transition: "transform 0.2s" }}>
            <img
              src={PlantLogo}
              alt="Naynesh Bhatia"
              className="card-img-top img-fluid"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
                margin: "1rem auto",
              }}
            />
            <div className="card-body text-center">
              <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>Naynesh Bhatia</h3>
              <p className="card-text" style={{ fontSize: "1rem", color: "#555" }}>Energy Engineer</p>
            </div>
          </div>
          <div className="team-member card" style={{ border: "none", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", transition: "transform 0.2s" }}>
            <img
              src={PlantLogo}
              alt="Pankaj Surwade"
              className="card-img-top img-fluid"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
                margin: "1rem auto",
              }}
            />
            <div className="card-body text-center">
              <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>Pankaj Surwade</h3>
              <p className="card-text" style={{ fontSize: "1rem", color: "#555" }}>Marketing Expert</p>
            </div>
          </div>
          <div className="team-member card" style={{ border: "none", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", transition: "transform 0.2s" }}>
            <img
              src={PlantLogo}
              alt="Tarun Kumar"
              className="card-img-top img-fluid"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
                margin: "1rem auto",
              }}
            />
            <div className="card-body text-center">
              <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>Tarun Kumar</h3>
              <p className="card-text" style={{ fontSize: "1rem", color: "#555" }}>Technical Expert</p>
            </div>
          </div>
          <div className="team-member card" style={{ border: "none", boxShadow: "0 4px 8px rgba(0,0,0,0.1)", transition: "transform 0.2s" }}>
            <img
              src={PlantLogo}
              alt="Sanjay Parihar"
              className="card-img-top img-fluid"
              style={{
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                objectFit: "cover",
                margin: "1rem auto",
              }}
            />
            <div className="card-body text-center">
              <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>Sanjay Parihar</h3>
              <p className="card-text" style={{ fontSize: "1rem", color: "#555" }}>Vastu Acharya</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA with Enquiry Form */}
      <section className="footer-cta">
        <div style={{ display: "grid", placeItems: "center" }}>
          <h2 className="commen_heading" style={{ color: "" }}>Transform Your Space Today</h2>
          <p style={{ color: "black" }}>
            Contact us to explore our personalized Vastu solutions and start your journey towards harmony and positivity.
          </p>
        </div>
        <div className="enquiry-form-inline">
          <h2>Enquiry Form</h2>
          <form onSubmit={handleSubmit} className="row g-4">
            <div className="col-md-6">
              <input
                type="text"
                name="contact_person"
                className="form-control input-underline"
                placeholder="Contact Person"
                value={enquiryData.contact_person}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col-md-6">
              <input
                type="email"
                name="email"
                className="form-control input-underline"
                placeholder="Email"
                value={enquiryData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col-md-6">
              <input
                type="text"
                name="company_name"
                className="form-control input-underline"
                placeholder="Company Name"
                value={enquiryData.company_name}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6">
              <input
                type="tel"
                name="phone"
                className="form-control input-underline"
                placeholder="Phone"
                value={enquiryData.phone}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col-12">
              <textarea
                name="message"
                className="form-control input-underline"
                placeholder="Message"
                value={enquiryData.message}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col-12">
              <select
                name="inquiry_type"
                className="form-select input-underline"
                value={enquiryData.inquiry_type}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Inquiry Type</option>
                {inquiryTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12">
              <button type="submit" className="btn">
                Submit Enquiry
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Enquiry Status */}
      {enquiryStatus && (
        <div className={`enquiry-status ${enquiryStatus}`}>
          {enquiryStatus === "success" ? "Enquiry sent successfully!" : "Error sending enquiry."}
          {enquiryStatus === "success" && (
            <div className="progress-bar">
              <div
                className="progress-bar-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AboutUs;